const apiPath = 'https://ferryopsapi.watertaxi.gl'; 

const config = {
    apiPath,
  };
  
  export default config;